module.exports = __webpack_public_path__ + "img/pinren2.480e72a3.jpg";